import { getOwner } from "@ember/application"
import { action, get } from "@ember/object"
import Route from "@ember/routing/route"
import { scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import isMobile from "../../../lib/is-mobile"

export default class PlannerRoute extends Route {
  @service("ember-store")
  store

  beforeModel() {
    // Update to store the last planner route
    // this.transitionTo('planbook.show.planner.week');
    if (isMobile().phone) {
      this.transitionTo("planbook.show.planner.day")
    }
  }

  lastRouteVisited = null

  @action
  didTransition() {
    // BLOGGABLE TRICK
    scheduleOnce("afterRender", () => {
      let applicationController = getOwner(this).lookup("controller:application")
      let currentRouteName = get(applicationController, "currentRouteName")
      if (currentRouteName === "planbook.show.planner.index") {
        if (isNone(this.lastRouteVisited)) this.lastRouteVisited = "planbook.show.planner.week"
        this.replaceWith(this.lastRouteVisited)
      } else {
        this.lastRouteVisited = currentRouteName
      }
    })
  }
}
